import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import Icon from './Icon';

interface CarouselPropsBase {
  title?: string;
  titleClassName?: string;
  icon?: IconProp;
}

type CarouselProps = React.HTMLAttributes<HTMLDivElement> & CarouselPropsBase;

function Carousel(props: CarouselProps) {
  const { icon, title, children, className, titleClassName, ...rest } = props;

  const classes = [];
  if (className) {
    classes.push(className);
  }

  const titleClasses = ['text-xl font-semibold flex-grow ml-4 flex items-center carousel-title'];
  if (titleClassName) {
    titleClasses.push(titleClassName);
  }

  return (
    <div {...rest} className={classes.join(' ')}>
      <div className={titleClasses.join(' ')}>
        {icon && <Icon icon={icon} className="mr-2" />}
        {title && <span>{title}</span>}
      </div>
      <div
        className={`hide-scrollbar flex items-stretch overflow-x-auto gap-x-4 px-4${
          title ? ' mt-3' : ''
        }`}
      >
        {children}
      </div>
    </div>
  );
}

export default Carousel;
